import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import Input from "../../../../common/Input";
import Dropdown from "../../../../primer/Dropdown";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import {getExamTypesOptions} from "../Data/examTypes";

const FavoriteExamsModal = ({show, setShow}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [exams, setExams] = useState([]);
    const [examinationGroupId, setExaminationGroupId] = useState("");
    const [filter, setFilter] = useState("");
    const [loading, setLoading] = useState(false);

    const fetchExams = () => {
        if (isEmpty(examinationGroupId)) {
            return toast.info("Παρακαλώ επιλέξτε κατηγορία εξέτασης.");
        }
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/examinations`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                filter: filter,
                examinationGroupId: examinationGroupId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                let sorted = res.data.data.sort((a, b) => String(a.description).localeCompare(b.description, "el")) || [];
                sorted.sort((a, b) => (b.erp_favorite === true) - (a.erp_favorite === true));
                for (let item of sorted) item.erp_amount = "";
                setExams(sorted);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleClick = (item) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/handle-favorite-exam`, {
            company: company.id,
            examId: item.id,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                fetchExams();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αγαπημένες Εξετάσεις</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <div style={{display: "flex", gap: "10px"}} onKeyDown={(e) => {
                                if (e.key === "Enter") fetchExams();
                            }}>
                                <div style={{ flex: "4" }}>
                                    <Dropdown
                                        name={"examType"}
                                        label={"Κατηγορία εξέτασης"}
                                        options={getExamTypesOptions()}
                                        defaultValue={getExamTypesOptions().find((el) => el.value === examinationGroupId)}
                                        onChange={(e) => setExaminationGroupId(e.value)}
                                    />
                                </div>
                                <div style={{ flex: "4" }}>
                                    <Input
                                        name={"filter"}
                                        label={"Φίλτρο"}
                                        value={filter}
                                        placeholder={"Αναζήτηση εξετάσεων"}
                                        onChange={(e) => setFilter(e.target.value)}
                                    />
                                </div>
                                <Button style={{ flex: "4", maxHeight: "32px", marginTop: "28px" }} size={"sm"} disabled={loading} onClick={() => fetchExams()}>
                                    Αναζήτηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                </Button>
                            </div>
                            {exams.length > 0 && (
                                <div style={{maxHeight: "60vh", overflowY: "auto"}} className={"mt-1"}>
                                    {exams.some((el) => el.erp_favorite) && (
                                        <div style={{display: "flex"}}>
                                            <div className={"mb-1"}>
                                                Με κίτρινο χρώμα αναγράφονται οι αγαπημένες εξετάσεις
                                            </div>
                                        </div>
                                    )}
                                    <table className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "70%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Εξέταση</th>
                                            <th>Τιμή</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {exams.map((item, idx) => (
                                            <tr key={`examsModal-${idx}`} style={{backgroundColor: item?.erp_favorite ? "#fcf99f" : ""}}>
                                                <td>{item.description}</td>
                                                <td>{item.price}</td>
                                                <td>
                                                    {item?.erp_favorite ? (
                                                        <Badge bg={"danger"} style={{cursor: "pointer"}} onClick={() => handleClick(item)}>Αφαίρεση</Badge>
                                                    ) : (
                                                        <Badge bg={"success"} style={{cursor: "pointer"}} onClick={() => handleClick(item)}>Προσθήκη</Badge>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default FavoriteExamsModal;
